import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

import LoadingSpinner from 'static/three-oh/src/components/LoadingSpinner/LoadingSpinner';

const LazyMergeApproval = Loadable({
  loader: () => import(
    /* webpackChunkName: "MergeApproval" */
    './MergeApproval/'
  ),
  loading: LoadingSpinner,
});

const LazyOpenMergeRequests = Loadable({
  loader: () => import(
    /* webpackChunkName: "OpenMergeRequests" */
    './OpenMergeRequests/'
  ),
  loading: LoadingSpinner,
});

const LazyMergeRequest = Loadable({
  loader: () => import(
    /* webpackChunkName: "MergeRequest" */
    './MergeRequest/'
  ),
  loading: LoadingSpinner,
});

const LazyProvisionSchools = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ProvisionSchools" */
      './ProvisionSchools/'
    ),
  loading: LoadingSpinner,
});

const LazyPygmalion = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Pygmalion" */
      './Pygmalion/'
    ),
  loading: LoadingSpinner,
});

const LazyUserDash = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "UserDash" */
      './UserDash/'
    ),
  loading: LoadingSpinner,
});

const LazyBulkRoster = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "BulkRoster" */
      './BulkRoster/'
    ),
  loading: LoadingSpinner,
});

const ChironRoutes = [
  <Route
    key="mergeApproval"
    path={['/chiron/merge-approval/:mergeRequestId/']}
    component={LazyMergeApproval}
  />,
  <Route
    key="mergeApproval"
    path={['/chiron/merge-approval/']}
    component={LazyOpenMergeRequests}
  />,
  <Route
    key="mergeRequest"
    path={['/chiron/merge-request/']}
    component={LazyMergeRequest}
  />,
  <Route
    key="provisionSchools"
    path={['/chiron/provision-schools/']}
    component={LazyProvisionSchools}
  />,
  <Route
    key="pygmalion"
    path={['/chiron/pygmalion/']}
    component={LazyPygmalion}
  />,
  <Route
    key="userDash"
    path={['/chiron/user-dash/:userId?/']}
    component={LazyUserDash}
  />,
  <Route
    key="bulkRoster"
    path={['/chiron/bulk-roster/']}
    component={LazyBulkRoster}
  />,
];

export default ChironRoutes;
